import axios from 'axios';
import store from '../store/index'

export const uploadMeetingFile = async function (fileInfo) {
  const targetAxios = axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API,
  });
  try {
    const result = await targetAxios.post(
      ``,
      fileInfo.fileData,
      {
        headers: {
          Authorization: `Bearer ${store.getters.getToken}`,
          'Content-Type': 'text/plain;charset=utf-8',
        },
      },
    );
    return result;
  } catch (e) {
    return e.response
  }
};
